module.exports = __webpack_public_path__ + "static/img/cptj_jcjg_icon.png";